import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { MatIconModule } from '@angular/material/icon';
import { AppTranslateModule } from '@core/app-translate.module';

import { AlertComponent } from './alert.component';
import { MatButtonModule } from '@angular/material/button';

export const imports: NgModule['imports'] = [FlexLayoutModule, MatButtonModule, MatIconModule];

@NgModule({
  declarations: [AlertComponent],
  imports: [...imports, CommonModule, AppTranslateModule],
  exports: [AlertComponent],
})
export class AlertModule {}
